import jsPDF from "jspdf";
import html2canvas from "html2canvas";  

    {/*const buildEssentialsPrompt = (groupAverages) => {
        // 1. Filter low percentage groups (< 40%)
        const lowGroups = Object.entries(groupAverages)
          .filter(([group, score]) => score < 40)
          .map(([group, score]) => ({ group, score }));
    
        // 2. Handle case where all groups are healthy
        if (lowGroups.length === 0) {
          return "All group scores are above 40%. No vulnerabilities reported.";
        }
    
        // 3. Build report context
        let reportContext = `Generate a formal cyber security report highlighting vulnerabilities a business is exposed to due to a lack of significant progress on implementing the requirements.\n\nFor each requirement:\n- State the requirement name and score\n- Provide a clear detailed risk explanation (why this is a vulnerability)\n- Suggest actionable mitigation strategies\n\nUse the additional context provided for each requirement if available.\n\nRespond ONLY with a valid JSON array of objects. Do not include code fences, markdown, or extra commentary. Each object must contain exactly these keys: "group", "score", "risk", "mitigation". Do not skip any group below.\n\n`;
    
        // 4. Add each low-score group with extra context
        lowGroups.forEach((g, index) => {
          const extra = categoryContext[g.group] || "";
          reportContext += `${index + 1}. ${g.group} (Score: ${g.score}%)\nContext: ${extra}\n\n`;
        });
    
        //console.log(reportContext);
        return reportContext;
      };
    
    
      const handleEssentialsDocSubmit = async () => {
        try {
          // Step 0: Set loading
          setResponseBySection(prev => ({
            ...prev,
            essentialsReport: { ...prev.essentialsReport, loading: true },
          }));
    
          // Step 1: Build prompt
          const finalPrompt = buildEssentialsPrompt(essentialsAnswers);
          
          const options = {
            method: "POST",
            headers: {
              Authorization: "Bearer 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", // Add API key
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              model: "sonar",
              messages: [
                {
                  role: "system",
                  content:
                    "You are a cybersecurity auditor. Respond ONLY with a valid JSON array of vulnerabilities (no code fences, no markdown). Each object must have: question, risk, mitigation.",
                },
                { role: "user", content: finalPrompt },
              ],
            }),
          };
    
          // Step 2: Call Perplexity API
          const res = await fetch("https://api.perplexity.ai/chat/completions", options);
          const data = await res.json();
          let rawMessage = data?.choices?.[0]?.message?.content || "[]";
    
          // Step 3: Sanitize JSON
          rawMessage = rawMessage.replace(/```json/g, "").replace(/```/g, "").trim();
    
          // Step 4: Parse JSON
          let vulnerabilities = [];
          try {
            const parsed = JSON.parse(rawMessage);
            if (Array.isArray(parsed)) {
              vulnerabilities = parsed;
            } else if (parsed?.vulnerabilities) {
              vulnerabilities = parsed.vulnerabilities;
            }
          } catch (err) {
            console.error("JSON parse error:", err, rawMessage);
          }
    
          // Step 5: Build HTML in memory
          const container = document.createElement("div");
          container.style.width = "600px";
          container.style.fontFamily = "Arial, sans-serif";
          container.style.lineHeight = "1.5";
          container.style.color = "#222";
    
          // Add logo and title
          container.innerHTML = `
            <div>
              <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:20px;">
                <img src="PerJoint.png" style="width:250px; height:auto;"/>
                <div style="text-align:right; font-size:10pt; color:#444;">
                  ${new Date().toLocaleDateString()}
                </div>
              </div>
              <h1 style="font-size:20pt; background:#1e4a91; color:#fff; padding:5px; margin:5px 0;">Cyber Essentials Assessment Report</h1>
              <hr/>
            </div>
          `;
    
          // Add issues
          vulnerabilities.forEach(v => {
            const issueDiv = document.createElement("div");
            issueDiv.className = "issue";
            issueDiv.style.background = "#f9f9f9";
            issueDiv.style.border = "1px solid #ccc";
            issueDiv.style.borderRadius = "6px";
            issueDiv.style.padding = "10px";
            issueDiv.style.marginBottom = "20px";
    
            issueDiv.innerHTML = `
              <p style="background:#4F71A7; color:#fff; padding:3px; font-size:8pt;"><b>Risks</b></p>
              <p style="font-size:8pt;">${v.risk}</p>
              <p style="background:#859DC5; color:#fff; padding:3px; font-size:8pt;"><b>Mitigations</b></p>
              <p style="font-size:8pt;">${v.mitigation}</p>
            `;
            container.appendChild(issueDiv);
          });
    
          document.body.appendChild(container);
    
          // Step 6: Generate PDF with html2canvas per issue
          const pdf = new jsPDF("p", "pt", "a4");
          const pageHeight = pdf.internal.pageSize.height;
          let yOffset = 40; // top margin
    
          // First, render the header/logo
          const header = container.children[0]; // logo + title
          const canvasHeader = await html2canvas(header, { scale: 1.5 });
          const imgHeader = canvasHeader.toDataURL("image/png");
          const imgHeaderHeight = (canvasHeader.height * 520) / canvasHeader.width;
          pdf.addImage(imgHeader, "PNG", 40, yOffset, 520, imgHeaderHeight);
          yOffset += imgHeaderHeight + 10;
    
          // Render each issue
          const issues = Array.from(container.getElementsByClassName("issue"));
          for (let i = 0; i < issues.length; i++) {
            const issue = issues[i];
            const canvas = await html2canvas(issue, { scale: 1.3 });
            const imgData = canvas.toDataURL("image/png");
            const imgHeight = (canvas.height * 520) / canvas.width;
    
            // Check if fits current page
            if (yOffset + imgHeight > pageHeight - 40) {
              pdf.addPage();
              yOffset = 40;
            }
    
            pdf.addImage(imgData, "JPEG", 40, yOffset, 520, imgHeight, undefined, "FAST");
            yOffset += imgHeight + 10; // spacing
          }
    
          // Open PDF in a new browser tab
          window.open(pdf.output("bloburl"), "_blank");
          document.body.removeChild(container);
    
          // Step 7: Update state
          setResponseBySection(prev => ({
            ...prev,
            essentialsReport: {
              loading: false,
              message: rawMessage,
              citations: data?.citations || [],
              searchResults: data?.search_results || [],
            },
          }));
        } catch (err) {
          console.error(err);
          setResponseBySection(prev => ({
            ...prev,
            essentialsReport: {
              loading: false,
              message: "An error occurred.",
              citations: [],
              searchResults: [],
            },
          }));
        }
      };*/}

    const categoryContext = {
      "Accountability": {
          "Goal A1: Impact Assessment": 
          "Goal A1: Impact Assessment focuses on evaluating and maintaining awareness of how a system affects people, organizations, and society. It requires conducting an early Impact Assessment during system development, reviewing it with designated compliance reviewers, and ensuring it is updated and re-evaluated at least once a year.",
          "Goal A2: Oversight of significant adverse impacts": 
          "Goal A2: Oversight of Significant Adverse Impacts ensures that systems are evaluated and monitored for potential high-risk or restricted uses. It involves reviewing whether a system qualifies as a Restricted or Sensitive Use, documenting and reporting such uses according to compliance requirements, and conducting annual reviews to identify and report any systems that meet these criteria to the appropriate responsible authorities.",
          "Goal A3: Fit for purpose": 
          "Goal A3: Fit for Purpose ensures that AI systems are demonstrably effective, reliable, and appropriately aligned with their intended uses. It requires documenting how the system addresses specific problems, defining and analyzing model inputs, outputs, and limitations, and setting clear Responsible Release Criteria with defined performance metrics and error thresholds. Teams must evaluate system performance before release and periodically afterward, providing transparent evidence of fitness for purpose to customers. If evidence shows an intended use is unsupported, the use must be removed, documentation updated, and customers informed. All communications about the system’s benefits must be accurate and compliant with legal guidance.",
          "Goal A4: Data governance and management": 
          "Goal A4: Data Governance and Management ensures that data used within a system is properly defined, assessed, and managed according to its intended purpose. It involves specifying data requirements based on system use, stakeholders, and deployment regions; establishing clear procedures for data collection and processing; assessing the quality and suitability of existing datasets; defining methods for data evaluation; and documenting all assessments and evaluations within the Impact Assessment.",
          "Goal A5: Human oversight and control": 
          "Goal A5: Human Oversight and Control ensures effective human responsibility and supervision over a system during and after deployment. It requires identifying and documenting key stakeholders responsible for oversight, defining system features and materials that enable them to understand, manage, and, when necessary, override system behavior, and designing or guiding the creation of these oversight tools. The goal also involves establishing methods and metrics to evaluate the effectiveness of oversight functions under real-world conditions, setting Responsible Release Criteria, documenting evaluation results, and developing a management plan for any unmet criteria before the system’s release."
        },

      "Transparency": {
        "Goal T1: System intelligibility for decision making": 
        "Goal T1: System Intelligibility for Decision Making ensures that both decision-makers using system outputs and individuals affected by those decisions can understand and interpret the system’s behavior effectively. It requires identifying and documenting these stakeholders, designing system features, UX, reporting, and educational materials to support comprehension and reduce automation bias, and documenting how the design achieves these aims. The goal also involves defining evaluation methods and metrics to assess stakeholder understanding, setting Responsible Release Criteria, conducting and documenting pre-release evaluations, and creating corrective plans for any unmet criteria before release, with ongoing evaluations scheduled as needed.",
        "Goal T2: Communication to stakeholders": 
        "Goal T2: Communication to Stakeholders ensures clear, accurate, and up-to-date communication about a system’s purpose, capabilities, and limitations to those who decide to use or integrate it. It requires identifying and documenting relevant stakeholders, publishing detailed system documentation that covers intended uses, operational guidance, limitations, performance evidence, and areas requiring caution, and providing a Transparency Note for externally available platform services. The documentation must be reviewed and updated annually or whenever key changes, new information, or new uses arise.",
        "Goal T3: Disclosure of AI interaction": 
        "Goal T3: Disclosure of AI Interaction ensures transparency by informing stakeholders when they are interacting with or exposed to an AI system. It involves identifying and documenting all affected stakeholders, designing system interfaces and materials to clearly disclose the AI’s nature, and labeling any AI-generated image, audio, or video outputs. The goal also requires defining evaluation methods and Responsible Release Criteria to verify that stakeholders are properly informed, conducting and documenting pre-release evaluations, and establishing a schedule for ongoing assessments to maintain compliance."
      },

      "Fairness": {
        "Goal F1: Quality of service": 
        "Goal F1: Quality of Service ensures equitable performance across all demographic groups, with particular attention to marginalized and at-risk populations. It involves identifying and prioritizing these groups, evaluating datasets for inclusiveness, and collecting additional data to close representation gaps. The goal requires defining evaluation methods, metrics, and Responsible Release Criteria that set minimum performance targets and maximum allowable disparities between groups. Systems must be tested against these criteria, with justifiable factors documented for any gaps or differences. Pre-release results and evaluation schedules must be recorded, and customers must be informed about groups with performance shortfalls, disparities, and the factors contributing to them, with required inclusion in Transparency Notes for platform services.",
        "Goal F2: Allocation of resources and opportunities": 
        "Goal F2: Allocation of resources and opportunities ensures that systems allocate benefits, resources, and opportunities equitably across demographic groups, including marginalized populations. It requires identifying and documenting groups at risk of differential impact, evaluating data inclusiveness, and defining metrics and Responsible Release Criteria that limit disparities in allocation rates. The system must be tested to ensure these criteria are met and reassessed to minimize group differences, considering trade-offs between fairness and performance in consultation with legal representatives. Justifiable factors for remaining disparities must be documented, along with pre-release results and evaluation schedules. Customers must be informed about any unresolved differences and their explanations, with such disclosures included in required Transparency Notes for external platform services.",
        "Goal F3: Minimization of stereotyping, demeaning, and erasing outputs": 
        "Goal F3: Minimization of Stereotyping, Demeaning, and Erasing Outputs focuses on reducing harmful or biased content produced by a system toward identified demographic groups, including marginalized populations. It requires prioritizing at-risk groups, defining system components for evaluation, and creating a plan to assess risks of stereotyping, demeaning, or erasing those groups. The system must be tested according to this plan, with design elements reassessed—such as training data, features, and algorithms—to minimize these risks. Pre-release results and evaluation schedules must be documented, and customers must be informed about potential risks, with required inclusion in Transparency Notes for platform services.",
      },

      "Reliability & Safety": {
        "Goal RS1: Reliability and safety guidance": 
        "Goal RS1: Reliability and Safety Guidance ensures that systems operate safely and consistently within defined performance boundaries. It requires documenting clear definitions of reliable and safe behavior, acceptable error rates, and key operational factors affecting system performance. Teams must evaluate training and test datasets for adequate representation of intended uses and environmental contexts, define acceptable ranges for operational factors, and set specific conditions for special use cases requiring stricter thresholds. A comprehensive evaluation plan must be created and executed to verify safe and reliable operation, with results, ongoing evaluation schedules, and failure management procedures documented. Customers must receive clear information about system reliability, limitations, and unsupported uses, with these details included in required Transparency Notes for platform services.",
        "Goal RS2: Failures and remediations": 
        "Goal RS2: Failures and Remediations focuses on identifying, preventing, and managing predictable and unforeseen system failures to minimize adverse impacts on stakeholders. It requires defining predictable failure modes, including false positives and negatives, and documenting their potential effects. For each such failure, teams must establish and document a management approach—either designing solutions to prevent failures, implementing fallback options when prevention is not possible, or providing oversight training and documentation for resolution. The goal also mandates planning for unknown failures by defining rollback procedures, feature deactivation processes, update deployment timelines, and communication protocols for notifying stakeholders of failures and mitigations. Training and documentation must be provided to all responsible parties to ensure effective remediation and response.",
        "Goal RS3: Ongoing monitoring, feedback, and evaluation": 
        "Goal RS3: Ongoing Monitoring, Feedback, and Evaluation ensures continuous oversight of system health, performance, and compliance. It requires establishing a detailed inventory of monitoring methods, including analytics, alerts, and feedback channels for customers and the public, along with standard operating procedures for reproducing failures, prioritizing events, scheduling reviews, and escalating critical issues. The goal mandates assessing new uses or operational factor changes to determine support feasibility, updating evaluations, Impact Assessments, customer documentation, and Transparency Notes as needed. Sensitive Uses require specific evaluations, with plans developed for unmet criteria. Regularly scheduled Ongoing Evaluation Checkpoints must be performed, with actions taken to address gaps, including removing unsupported uses, updating documentation, revising communications, and escalating unresolved issues to responsible parties.",
      },

      "Privacy & Security": {
        "Goal PS1: Privacy Standard compliance": 
        "Goal PS1: Privacy Standard Compliance ensures that AI systems handle personal data responsibly, lawfully, and ethically in accordance with privacy principles. It requires minimizing data collection and retention (Data Minimization), restricting processing to clearly defined purposes (Purpose Limitation), and maintaining accurate and reliable data (Data Accuracy and Integrity). Systems must obtain informed user consent, provide control over data (User Consent and Control), and operate transparently while ensuring organizational accountability. Strong security measures must protect against unauthorized access or misuse (Security Safeguards), while fairness principles ensure non-discriminatory use of personal data (Fairness and Non-discrimination). Finally, systems must uphold and facilitate individuals’ data rights, including access, rectification, erasure, and portability (Data Subject Rights).",
        "Goal PS2: Security Policy compliance": 
        "Goal PS2: Security Policy Compliance ensures AI systems maintain robust protection for data, models, and infrastructure through comprehensive security practices. It requires encrypting sensitive data and controlling access (Data Security), securing and tracking AI models through encryption, versioning, validation, and auditing (Model Security), and enforcing strict authentication, role-based permissions, and API protections (Access Control and Authentication). Network defenses like firewalls, intrusion detection, and secure protocols must be in place (Network Security), alongside secure coding, patch management, vulnerability testing, and system configuration practices (System and Software Security). The goal also mandates establishing incident response, logging, monitoring, and disaster recovery procedures (Incident Response and Recovery), while ensuring adherence to relevant data protection regulations and industry standards (Regulatory Compliance).",
      },

      "Inclusiveness": {
        "Goal I1: Accessibility Standards compliance": 
        "Goal I1: Accessibility Standards Compliance ensures AI systems are inclusive and usable by people with diverse abilities through adherence to global accessibility standards and inclusive design principles. It requires compliance with WCAG, consideration of the European Accessibility Act and other relevant standards, and the application of inclusive design approaches—identifying exclusion, designing broadly beneficial solutions, and involving people with disabilities in the design and testing process. Systems must support multi-modal interactions, offer alternative text, ensure keyboard accessibility, use clear language, provide effective error handling, and allow customization of user interfaces. Accessibility testing, assistive technology compatibility, and usability evaluations must be conducted regularly. Continuous monitoring, user feedback collection, and iterative improvements are essential to maintaining and advancing accessibility over time.",
      },

      "Risk Management": {
        "Goal RM1: Risk Management Standards compliance (ISO 31000: 2018 and ISO/IEC 23894:2023)": 
        "Goal RM1: Risk Management Standards Compliance ensures AI systems adhere to ISO 31000:2018 and ISO/IEC 23894:2023 by applying a structured, comprehensive, and context-sensitive risk management framework. It requires tailoring processes to the organization’s objectives and context, involving stakeholders promptly, and anticipating, detecting, and addressing new risks in a timely manner. Risk decisions must consider historical and current information, acknowledging uncertainties, and incorporate human behavior and cultural factors at all stages. Continuous improvement through ongoing learning and experience is essential to maintaining effective risk management.",
      },

      "Impact Assessment": {
        "Goal IA1: To proactively identify and mitigate potential risks and negative impacts on individuals, groups, and society while maximizing the benefits of AI technology.": 
        "Goal IA1: Proactive Identification and Mitigation of AI Risks aims to minimize potential negative impacts of AI systems on individuals, groups, and society while maximizing their benefits. It involves assessing data quality, representativeness, and bias; ensuring algorithmic transparency, explainability, and fairness; and evaluating human-AI interactions for usability, control, and transparency. The goal requires assessing societal and ethical impacts, establishing ongoing monitoring and evaluation mechanisms, and implementing robust governance and accountability structures. Compliance with relevant laws and ethical standards must be maintained, and stakeholder engagement is essential to incorporate diverse perspectives and enable responsible AI development and deployment.",
      },

      "Data Quality Processing Framework": {
        "Goal DQ1: Within the context of AI, the overall goal of a data quality processing framework is to ensure that the data used for training, testing, and deploying AI models is of the highest quality. This is critical because the performance, accuracy, and fairness of AI models are directly dependent on the quality of the input data.": 
        "Goal DQ1: Data Quality Processing Framework ensures that data used to train, test, and deploy AI models meets the highest standards, as model performance, accuracy, and fairness depend on input quality. It defines key data quality dimensions—accuracy, completeness, consistency, timeliness, and relevance—and sets clear requirements aligned with business needs and regulations. The framework guides assessment processes to detect anomalies, measure metrics, and identify improvements, emphasizing continuous enhancement per ISO 5259-4:2024. Strong data governance assigns stewardship roles, while tools such as profiling, cleansing, validation, and enrichment support efficient quality management. Comprehensive documentation and transparent reporting ensure stakeholders understand and trust data quality initiatives.",
      },
    }
  
    const buildConformityPrompt = (groupAverages) => {
      const lowGroups = Object.entries(groupAverages)
        .filter(([group, score]) => score < 70)
        .map(([group, score]) => ({ group, score }));

      if (lowGroups.length === 0) {
        return "All group scores are above 70%. No vulnerabilities reported.";
      }

      let reportContext = `Generate a formal Non-Conformity report highlighting vulnerabilities for each requirement where the score is below 70%.\n\nStructure your response as a valid JSON object grouped by category, following this pattern:\n\n{
      "CategoryName": {
        "Goal Name": {
          "score": <number>,
          "risks": [
            { "risk": <string>, "mitigation": <string> },
            ...
          ]
        }
      }
    }\n\nDo NOT include code fences, markdown, or commentary.\n\n`;

      reportContext += `For each requirement below, use its category, full goal name, and score. Provide as many relevant risks and mitigations as possible.\n\n`;

      lowGroups.forEach((g, index) => {
        let foundCategory = "Unknown Category";
        let fullGoalName = g.group;
        let extra = "";

        // Search categoryContext for a key starting with the prefix
        for (const [category, goals] of Object.entries(categoryContext)) {
          for (const [goalKey, goalContext] of Object.entries(goals)) {
            // Match prefix, e.g. "Goal A1" matches "Goal A1: Impact Assessment"
            if (goalKey.startsWith(g.group)) {
              foundCategory = category;
              fullGoalName = goalKey;
              extra = goalContext;
              break;
            }
          }
          if (foundCategory !== "Unknown Category") break;
        }

        reportContext += `${index + 1}. Category: ${foundCategory}\n   Goal: ${fullGoalName}\n   Score: ${g.score}%\n   Context: ${extra}\n\n`;
      });

      return reportContext;
    };



    export const handleConformityDocSubmit = async (ConformityAnswers) => {
  try {
    // Step 1: Build prompt
    const finalPrompt = buildConformityPrompt(ConformityAnswers);
    console.log(finalPrompt);
    
    const options = {
      method: "POST",
      headers: {
        Authorization: "Bearer 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", // Add API key
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        model: "sonar",
        messages: [
          {
            role: "system",
            content:
              "You are a cybersecurity auditor. Respond ONLY with a valid JSON array or object. " +
              "Each object must contain: group, score, risks[]. Each risk must have: risk, mitigation.",
          },
          { role: "user", content: finalPrompt },
        ],
      }),
    };

    // Step 2: Call API
    const res = await fetch("https://api.perplexity.ai/chat/completions", options);
    const data = await res.json();
    let rawMessage = data?.choices?.[0]?.message?.content?.trim() || "[]";

    // Step 3: Parse JSON
    rawMessage = rawMessage.replace(/```json/g, "").replace(/```/g, "").trim();
    console.log("Raw model response:", rawMessage);

    let vulnerabilities = {};

    try {
      const parsed = JSON.parse(rawMessage);

      if (Array.isArray(parsed) && parsed.length > 0) {
        // If model returned a flat array
        vulnerabilities = parsed.reduce((acc, item) => {
          const { group, score, risks } = item;
          let category = "Uncategorized";

          for (const [cat, goals] of Object.entries(categoryContext)) {
            if (Object.keys(goals).includes(group)) {
              category = cat;
              break;
            }
          }

          if (!acc[category]) acc[category] = {};
          acc[category][group] = { score, risks };
          return acc;
        }, {});
      } else if (parsed && typeof parsed === "object") {
        // Already grouped
        vulnerabilities = parsed;
      }
    } catch (err) {
      console.error("JSON parse error:", err, rawMessage);
    }

    // Step 4: Build hidden container + render PDF
    const container = document.createElement("div");
    container.style.width = "700px";
    container.style.fontFamily = "Arial, sans-serif";
    container.style.lineHeight = "1.4";
    container.style.color = "#222";
    container.style.position = "absolute";
    container.style.top = "-9999px";
    container.style.left = "-9999px";
    document.body.appendChild(container);

    // ===== HEADER =====
    const header = document.createElement("div");
    header.innerHTML = `
      <div>
        <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:20px;">
          <img src="TramsJoint.png" style="width:250px; height:auto;"/>
          <div style="text-align:right; font-size:10pt; color:#444;">
            ${new Date().toLocaleDateString()}
          </div>
        </div>
        <h1 style="font-size:20pt; background:#1e4a91; color:#fff; padding:5px; margin:5px 0;">Conformity Analysis Report</h1>
        <hr/>
      </div>
    `;
    container.appendChild(header);

    // ===== SORT ORDER =====
    const CATEGORY_ORDER = [
      "Accountability",
      "Transparency",
      "Fairness",
      "Risk Management",
      "Impact Assessment",
      "Inclusiveness",
      "Reliability & Safety",
      "Privacy & Security",
      "Data Quality Processing Framework"
    ];

    const GOAL_ORDER = [
      "Goal A1: Impact Assessment",
      "Goal A2: Oversight of significant adverse impacts",
      "Goal A3: Fit for purpose",
      "Goal A4: Data governance and management",
      "Goal A5: Human oversight and control",
      "Goal T1: System intelligibility for decision making",
      "Goal T2: Communication to stakeholders",
      "Goal T3: Disclosure of AI interaction",
      "Goal F1: Quality of service",
      "Goal F2: Allocation of resources and opportunities",
      "Goal F3: Minimization of stereotyping, demeaning, and erasing outputs",
      "Goal RS1: Reliability and safety guidance",
      "Goal RS2: Failures and remediations",
      "Goal RS3: Ongoing monitoring, feedback, and evaluation",
      "Goal PS1: Privacy Standard compliance",
      "Goal PS2: Security Policy compliance",
      "Goal I1: Accessibility Standards compliance",
      "Goal RM1: Risk Management Standards compliance (ISO 31000: 2018 and ISO/IEC 23894:2023)",
      "Goal IA1: To proactively identify and mitigate potential risks and negative impacts on individuals, groups, and society while maximizing the benefits of AI technology.",
      "Goal DQ1: Within the context of AI, the overall goal of a data quality processing framework is to ensure that the data used for training, testing, and deploying AI models is of the highest quality. This is critical because the performance, accuracy, and fairness of AI models are directly dependent on the quality of the input data."
    ];

    // ===== BODY =====
    const sortedCategories = Object.entries(vulnerabilities).sort(([a], [b]) => {
      const indexA = CATEGORY_ORDER.indexOf(a);
      const indexB = CATEGORY_ORDER.indexOf(b);
      return (indexA === -1 ? CATEGORY_ORDER.length : indexA) - (indexB === -1 ? CATEGORY_ORDER.length : indexB);
    });

    sortedCategories.forEach(([categoryName, goals]) => {
      // Category header
      const categoryHeader = document.createElement("h2");
      categoryHeader.textContent = categoryName;
      categoryHeader.style.fontSize = "16pt";
      categoryHeader.style.color = "#1e4a91";
      categoryHeader.style.marginTop = "30px";
      container.appendChild(categoryHeader);

      // Sort goals
      const sortedGoals = Object.entries(goals).sort(([goalA], [goalB]) => {
        const indexA = GOAL_ORDER.indexOf(goalA);
        const indexB = GOAL_ORDER.indexOf(goalB);
        return (indexA === -1 ? GOAL_ORDER.length : indexA) - (indexB === -1 ? GOAL_ORDER.length : indexB);
      });

      // Loop over sorted goals
      sortedGoals.forEach(([goalName, goalData]) => {
        const goalTitle = document.createElement("h3");
        goalTitle.textContent = `${goalName} (Score: ${Number(goalData.score).toFixed(2)}%)`;
        goalTitle.style.color = "#333";
        goalTitle.style.fontSize = "13pt";
        goalTitle.style.marginTop = "15px";
        container.appendChild(goalTitle);

        const table = document.createElement("table");
        table.style.width = "100%";
        table.style.borderCollapse = "collapse";
        table.style.marginBottom = "20px";

        const thead = document.createElement("thead");
        thead.innerHTML = `
          <tr>
            <th style="border:1px solid #444; background:#1e4a91; color:#fff; padding:6px;">Non-Conformity</th>
            <th style="border:1px solid #444; background:#1e4a91; color:#fff; padding:6px;">Corrective Action</th>
          </tr>
        `;
        table.appendChild(thead);

        const tbody = document.createElement("tbody");
        (goalData.risks || []).forEach(r => {
          const row = document.createElement("tr");
          row.innerHTML = `
            <td style="border:1px solid #ccc; padding:6px; vertical-align:top;">${r.risk}</td>
            <td style="border:1px solid #ccc; padding:6px; vertical-align:top;">${r.mitigation}</td>
          `;
          tbody.appendChild(row);
        });
        table.appendChild(tbody);
        container.appendChild(table);
      });
    });

    // Step 5: Generate PDF
    const pdf = new jsPDF("p", "pt", "a4");
    const pageHeight = pdf.internal.pageSize.height;
    let yOffset = 40;

    const sections = Array.from(container.children);
    for (let i = 0; i < sections.length; i++) {
      const canvas = await html2canvas(sections[i], { scale: 1.3 });
      const imgData = canvas.toDataURL("image/png");
      const imgHeight = (canvas.height * 520) / canvas.width;

      if (yOffset + imgHeight > pageHeight - 40) {
        pdf.addPage();
        yOffset = 40;
      }

      pdf.addImage(imgData, "JPEG", 40, yOffset, 520, imgHeight, undefined, "FAST");
      yOffset += imgHeight + 10;
    }

    // Step 6: Show PDF
    const pdfBlob = pdf.output("blob");
    const blobUrl = URL.createObjectURL(pdfBlob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = "Conformity_Report.pdf";
    link.click();
    URL.revokeObjectURL(blobUrl);

    // Cleanup
    document.body.removeChild(container);

  } catch (err) {
    console.error("Error generating report:", err);
  }
};


 